import Reveal from "./Reveal";
import { Clock, Disc3 } from "lucide-react";
import { SITE } from "../config/siteConfig";

export default function Programm() {
  return (
    <section id="programm" className="py-16 md:py-28" data-testid="section-programm">
      <div className="mx-auto max-w-[1200px] px-5 md:px-10">
        <Reveal>
          <p className="eyebrow text-brand-dark">
            <span className="eyebrow-rule" aria-hidden="true" />
            Programm
          </p>
          <h2 className="h2 mt-4">Vier Nächte. Ein Treffpunkt.</h2>
          <p className="mt-5 max-w-[62ch] text-base leading-relaxed md:text-lg">
            {SITE.programIntro}
          </p>
        </Reveal>

        <div className="mt-10 grid gap-4 sm:grid-cols-2">
          {SITE.program.map((p, i) => (
            <Reveal key={p.date} delay={i * 0.06} className="h-full">
              <article
                data-testid={`program-card-${i + 1}`}
                className="card-tile h-full p-6 transition-colors duration-200 hover:border-brand-red md:p-8"
              >
                <div className="flex items-center justify-between gap-3">
                  <p className="text-sm font-bold uppercase tracking-[0.16em] text-brand-dark">
                    {p.weekday}
                  </p>
                  <span className="h-[3px] w-8 bg-brand-red" aria-hidden="true" />
                </div>
                <p className="mt-4 font-display text-[26px] leading-none md:text-3xl">
                  {p.date}
                </p>
                <p className="mt-5 flex items-center gap-2 font-semibold">
                  <Clock className="h-4 w-4 shrink-0 text-brand-red" aria-hidden="true" />
                  {p.time}
                </p>
                <p className="mt-2 flex items-start gap-2 font-semibold text-brand-dark">
                  <Disc3 className="h-4 w-4 shrink-0" aria-hidden="true" />
                  <span>
                    {p.dj.startsWith("DJ") ? "" : "DJ: "}
                    {p.djUrl ? (
                      <a
                        data-testid={`program-dj-link-${i + 1}`}
                        href={p.djUrl}
                        target="_blank"
                        rel="noopener noreferrer"
                        className="underline decoration-brand-red underline-offset-4 transition-colors duration-200 hover:text-brand-red"
                      >
                        {p.dj}
                      </a>
                    ) : (
                      <span data-testid={`program-dj-${i + 1}`}>{p.dj}</span>
                    )}
                  </span>
                </p>
              </article>
            </Reveal>
          ))}
        </div>

        <Reveal delay={0.1}>
          <p className="mt-6 text-sm text-ink/60">{SITE.programNote}</p>
        </Reveal>
      </div>
    </section>
  );
}
